import {
  apolloClient,
  fetchBanners,
  fetchMarketById,
  fetchPage,
  fetchPageLinks,
  GET_PARTNERS_QUERY,
  GetPartnersQuery,
  GetPartnersQueryVariables,
  localeToMarketCode,
  PageProps,
  Partners_Filter,
  Partners_Translations_Filter,
} from '@instabox/consumer-web-shared'
import type { GetStaticProps } from 'next'

import { HomePage } from '../components/HomePage'

export interface HomePageProps extends PageProps {
  partners: GetPartnersQuery['partners']
}

export default HomePage

const SLUG = 'home'

export const getStaticProps: GetStaticProps<HomePageProps> = async ({ locale }) => {
  const marketCode = localeToMarketCode(locale)
  const [
    page,
    pageLinks,
    banners,
    {
      data: { marketById },
    },
  ] = await Promise.all([
    fetchPage(locale, SLUG),
    fetchPageLinks(locale),
    fetchBanners(locale, SLUG),
    fetchMarketById(marketCode),
  ])

  const filter: Partners_Filter = {
    markets: {
      markets_code: { code: { _eq: marketCode } },
    },
  }
  const translationsFilter: Partners_Translations_Filter = {
    languages_code: {
      _eq: locale,
    },
  }
  const {
    data: { partners },
  } = await apolloClient.query<GetPartnersQuery, GetPartnersQueryVariables>({
    query: GET_PARTNERS_QUERY,
    variables: {
      filter,
      translations_filter: translationsFilter,
    },
  })

  return {
    props: {
      market: marketById,
      pageLinks,
      partners,
      banners,
      fullBleed: true,
      ...page,
    },
    notFound: !page,
    revalidate: 60,
  }
}
